import React from "react";
import { TrashIcon } from "@heroicons/react/outline";
import { Card } from "../ui/Cards/Card";
import { DropdownMenuVariant } from "../DropdownMenu";
import { Workflow } from "../Workflows/types";
import { Agent } from "../ui/icons";

interface WorkflowCardProps {
  workflow: Workflow;
  workspaceId: string;
  onDelete: (workflow: Workflow) => void;
}

const WorkflowCard: React.FC<WorkflowCardProps> = ({
  workflow,
  workspaceId,
  onDelete,
}) => (
  <Card
    link={`/workspace/${workspaceId}/workflow/${workflow.id}`}
    title={workflow.name}
    icon={<Agent className="h-6 w-6 text-gray-400" />}
    actions={[
      {
        id: "delete",
        label: "Delete",
        variant: DropdownMenuVariant.DESTRUCTIVE,
        icon: TrashIcon,
        onClick: () => onDelete(workflow),
      },
    ]}
    item={workflow}
  />
);

export default WorkflowCard;
